import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import type DepartmentModel from 'scaleflow/models/department';

class CompanyDepartmentRoadmapRoute extends Route {
  model() {
    const department = this.modelFor(
      'departments.department',
    ) as DepartmentModel;
    return department;
  }
}

export default instrumentRoutePerformance(CompanyDepartmentRoadmapRoute);
